import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { HttpClient } from '@angular/common/http';
import {
  TranslateLoader,
  TranslateModule
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { VALIDATOR_SERVICE_TOKEN } from '@m1/components';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { CustomerOnboardingService, Configuration } from './core/openapi';
import { ValidatorsService } from './core/services/validators.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    CustomerOnboardingService,
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: environment.basePath,
          credentials: {
            oauth2: environment.cognito.token,
          },
        }),
    },
    { provide: VALIDATOR_SERVICE_TOKEN, useClass: ValidatorsService },
  ],
};
